const MAX_CHAPTERS = 100;

export function truncateTOC(
    pages: Array<{
        id: number;
        parent_id: number;
        _indent: number;
    }>
) {
    if (pages.length <= MAX_CHAPTERS) {
        const index: Record<number, number> = {};
        for (let i = 0; i < pages.length; i++) {
            const p = pages[i];
            if (p.parent_id === 0) {
                index[p.id] = 0;
            } else {
                index[p.id] = index[p.parent_id] + 1;
            }

            pages[i]._indent = index[p.id];
        }

        return pages;
    }

    return pages.filter((i) => i.parent_id === 0);
}

export function isTOCIndented(
    pages: Array<{
        parent_id: number;
    }>
) {
    for (let i = 0; i < pages.length; i += 1) {
        if (pages[i].parent_id > 0) {
            return true;
        }
    }

    return false;
}
